import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const Choose: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    aria-hidden={!title}
    focusable='false'
    width={width}
    height={height}
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.992 1.5V3H12H13.008V1.5V0H12H10.992V1.5ZM6.33598 2.34002L5.62819 3.04812L6.6901 4.11002L7.75198 5.1719L8.46002 4.46388L9.16805 3.75586L8.1059 2.6939L7.04374 1.63195L6.33598 2.34002ZM15.8939 2.6941L14.832 3.75626L15.54 4.46402L16.2481 5.17181L17.31 4.1099L18.3719 3.04802L17.6639 2.33998L16.9559 1.63195L15.8939 2.6941ZM9 10.296C9 13.2132 8.99177 15.6 8.98171 15.6C8.97163 15.6 8.47754 15.4378 7.88371 15.2395C6.64128 14.8248 6.4573 14.7797 6.012 14.7805C5.13026 14.7821 4.38053 15.1139 3.77971 15.7683C3.57278 15.9937 3.45725 16.1625 3.30996 16.4547C3.07884 16.9133 3.00024 17.2992 3.0001 17.976L3 18.4201L5.6461 21.0661L8.29219 23.7121L9 23.004L9.70781 22.2959L7.35991 19.9479L5.01202 17.5999L5.03998 17.494C5.11946 17.1926 5.37259 16.9367 5.70379 16.8227C6.00415 16.7194 5.90254 16.6926 8.54261 17.5714C9.85678 18.0089 10.9455 18.3719 10.962 18.378C10.986 18.3869 10.992 17.2407 10.992 12.6971V7.0051L11.622 7.01254L12.252 7.02L12.3943 7.08665C12.5832 7.17511 12.7194 7.28995 12.8262 7.45097C13.0063 7.72226 12.9934 7.48104 13.0019 10.7164L13.0096 13.6208L16.0028 15.1204L18.996 16.62L19.0021 20.31L19.0081 24H20.0041H21V19.692V15.384L18.0008 13.8844L15.0015 12.3847L14.9936 9.97836C14.9849 7.32895 14.9932 7.4821 14.8332 7.02C14.505 6.07178 13.7054 5.33856 12.7291 5.09057C12.3936 5.00537 12.0943 4.992 10.5215 4.992H9V10.296ZM4.008 8.004V9H5.508H7.008V8.004V7.008H5.508H4.008V8.004ZM16.992 8.004V9H18.492H19.992V8.004V7.008H18.492H16.992V8.004Z'
      fill={fill}
    />
  </svg>
)

export default Choose
